
    // ---- Scroll-scrubbed hero video (Apple-style frame-by-frame on scroll) ----
    (function(){
      var track = document.querySelector('.hero');
      var video = document.querySelector('.hero__video');
      if(!track || !video) return;

      // Flip to true to ship the static image on phones if real-device scrubbing lags.
      var FORCE_IMAGE_ON_MOBILE = false;

      var reduce  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isPhone = window.matchMedia('(max-width:600px)').matches ||
                    (navigator.maxTouchPoints > 1 && /iP(hone|od)/.test(navigator.userAgent));

      // iOS Safari: muted + playsinline MUST be set as properties too, or programmatic
      // seeking silently no-ops on iPhone.
      video.muted = true; video.defaultMuted = true; video.playsInline = true;
      video.setAttribute('muted',''); video.setAttribute('playsinline','');
      try{ video.pause(); }catch(e){}

      // Fallback path: keep the static poster image, don't scrub, keep hero at 100svh.
      if(reduce || (FORCE_IMAGE_ON_MOBILE && isPhone)){
        video.preload = 'none';
        return;
      }

      track.classList.add('is-scrub');            // expand to the tall scroll track
      var stickyEl = track.querySelector('.hero__sticky');
      var topbarEl = document.querySelector('.topbar');
      function pin(){
        if(!stickyEl) return;
        var r = track.getBoundingClientRect(), vh = window.innerHeight;
        if(topbarEl) topbarEl.classList.toggle('is-solid', r.bottom <= 80);   // solid nav once the hero is scrolled past
        if(r.top >= 0){ stickyEl.classList.remove('is-fixed','is-bottom'); }          // before hero
        else if(r.bottom <= vh){ stickyEl.classList.remove('is-fixed'); stickyEl.classList.add('is-bottom'); }  // after hero
        else { stickyEl.classList.remove('is-bottom'); stickyEl.classList.add('is-fixed'); }                    // pinned
      }

      var duration = 6.046, ready = false, primed = false, raf = null;
      var scrubEnd = 5.3;                          // stop on the settled product shot, before the empty fly-out tail
      var currentT = 0;

      video.addEventListener('loadedmetadata', function(){ if(video.duration){ duration = video.duration; scrubEnd = Math.max(1, duration - 0.75); } });

      function markReady(){
        if(ready) return;
        ready = true;
        video.classList.add('is-ready');          // crossfade video over the poster
      }
      video.addEventListener('canplaythrough', markReady);
      video.addEventListener('canplay', function(){ setTimeout(markReady, 500); });

      // iOS needs one *successful* play() to unlock the decoder before seeks paint. Because the
      // clip now loads lazily (deferred fetch), the first gesture can land before the video is
      // ready — so we only claim the unlock once play() actually resolves, and keep listening
      // (re-arming on each gesture) until it does. Guarded with `priming` so we don't spam play().
      var primeEvents = ['touchstart','wheel','scroll','pointerdown'], priming = false;
      function detachPrime(){ primeEvents.forEach(function(ev){ window.removeEventListener(ev, prime); }); }
      function prime(){
        if(primed || priming) return;
        priming = true;
        var p = video.play();
        if(p && p.then){
          p.then(function(){ primed = true; video.pause(); detachPrime(); })
           .catch(function(){ priming = false; });   // not ready yet — let the next gesture retry
        } else {
          primed = true; try{ video.pause(); }catch(e){} detachPrime();
        }
      }
      primeEvents.forEach(function(ev){ window.addEventListener(ev, prime, {passive:true}); });

      function progress(){
        var rect = track.getBoundingClientRect();
        var scrollable = track.offsetHeight - window.innerHeight;
        if(scrollable <= 0) return 0;
        return Math.min(Math.max(-rect.top / scrollable, 0), 1);
      }

      function loop(){
        pin();                                     // JS pin — keeps the hero fixed (robust vs CSS-sticky quirks)
        if(ready){
          var target = progress() * scrubEnd;
          currentT += (target - currentT) * 0.22;  // eased tracking (reference smoothness)
          if(Math.abs(target - currentT) < 0.004) currentT = target;
          if(!video.seeking){ try{ video.currentTime = currentT; }catch(e){} }
        }
        raf = requestAnimationFrame(loop);
      }
      raf = requestAnimationFrame(loop);           // start immediately so pinning works even before the video loads

      // Load the whole clip into memory as a Blob → instant, lag-free, server-independent
      // seeking. (HTTP Range support varies by host; a Blob URL is always fully seekable, which
      // is what keeps scrubbing responsive — especially on slower mobile connections.)
      // DEFERRED off the initial page-load path: the ~9MB clip is only needed once the user
      // scrolls, so we hold it out of the LCP window and fetch on first input or during idle.
      var videoLoadStarted = false;
      function startVideoLoad(){
        if(videoLoadStarted) return; videoLoadStarted = true;
        var srcEl = video.querySelector('source');
        var srcUrl = srcEl ? srcEl.src : video.currentSrc;
        fetch(srcUrl).then(function(r){ return r.blob(); }).then(function(b){
          video.src = URL.createObjectURL(b);
          video.load();
        }).catch(function(){
          // Fallback: play the <source> directly (fine where the host supports range requests).
          if(video.readyState >= 3) markReady();
        });
      }
      // Trigger on the first scroll/input (when scrubbing actually matters)...
      ['touchstart','wheel','scroll','pointerdown'].forEach(function(ev){
        window.addEventListener(ev, startVideoLoad, {once:true, passive:true});
      });
      // ...or during idle time after load, so it's ready even without interaction — but never
      // competing with the initial paint.
      function scheduleIdleVideoLoad(){
        if('requestIdleCallback' in window){ requestIdleCallback(startVideoLoad, {timeout:4000}); }
        else { setTimeout(startVideoLoad, 2500); }
      }
      if(document.readyState === 'complete'){ scheduleIdleVideoLoad(); }
      else { window.addEventListener('load', scheduleIdleVideoLoad, {once:true}); }
    })();

    // mobile menu open/close
    (function(){
      var menu = document.getElementById('mobileMenu');
      var openBtn = document.querySelector('.hamburger');
      var closeBtn = document.querySelector('.mobile-menu__close');
      if(!menu || !openBtn) return;
      function open(){ menu.classList.add('open'); menu.setAttribute('aria-hidden','false'); openBtn.setAttribute('aria-expanded','true'); }
      function close(){ menu.classList.remove('open'); menu.setAttribute('aria-hidden','true'); openBtn.setAttribute('aria-expanded','false'); }
      openBtn.addEventListener('click', open);
      if(closeBtn) closeBtn.addEventListener('click', close);
      menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
    })();

    // touch/click toggle for desktop dropdowns (hover handles pointer devices)
    (function(){
      document.querySelectorAll('.nav-trigger').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var panel = btn.parentElement.querySelector('.menu-panel');
          var isOpen = panel.classList.toggle('open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
      document.addEventListener('click', function(e){
        if(!e.target.closest('.nav-item')){
          document.querySelectorAll('.menu-panel.open').forEach(function(p){ p.classList.remove('open'); });
        }
      });
    })();

    // reveal-on-scroll
    (function(){
      var els=document.querySelectorAll('.reveal');
      if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
      var io=new IntersectionObserver(function(en){ en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:0.12});
      els.forEach(function(e){ io.observe(e); });
    })();
    // newsletter (demo)
    (function(){
      var f=document.getElementById('newsForm'); if(!f) return;
      f.addEventListener('submit', function(e){ e.preventDefault(); var i=f.querySelector('input'); if(!i.value || i.value.indexOf('@')<0){ i.focus(); return; } f.style.display='none'; document.getElementById('newsOk').hidden=false; });
    })();
  
/* ===================== PDP: variants, gallery, qty, accordions, cart ===================== */
(function(){
  var root = document.getElementById('gfg-pdp');
  if(!root) return;
  var money = c => '$' + (c/100).toFixed(2);
  var variants = JSON.parse(document.getElementById('gfg-variants').textContent || '[]');
  var optCount = parseInt(root.dataset.optionCount || '1', 10);
  var selected = variants.find(v=>v.id == root.dataset.currentVariant) || variants.find(v=>v.available) || variants[0];
  var chosen = selected ? selected.options.slice() : [];

  function findVariant(){
    return variants.find(function(v){
      for(var i=0;i<optCount;i++){ if(v.options[i] !== chosen[i]) return false; }
      return true;
    });
  }
  function fmtPrice(v){
    var html = money(v.price);
    if(v.compare_at_price && v.compare_at_price > v.price){
      html = '<span class="was">'+money(v.compare_at_price)+'</span> <span class="now">'+money(v.price)+'</span> <span class="save">Save '+money(v.compare_at_price - v.price)+'</span>';
    } else { html = '<span class="now">'+money(v.price)+'</span>'; }
    return html;
  }
  function render(){
    var v = findVariant();
    // mark sold-out option buttons (only meaningful for 1-option products; keep simple)
    root.querySelectorAll('.optbtn').forEach(function(b){
      var oi = +b.dataset.optIndex, val = b.dataset.value;
      b.classList.toggle('active', chosen[oi] === val);
      // grey out option values with no available variant, given the other currently-selected options
      var soldOut = !variants.some(function(vr){
        if(!vr.available) return false;
        for(var i=0;i<optCount;i++){ if(vr.options[i] !== (i===oi ? val : chosen[i])) return false; }
        return true;
      });
      b.classList.toggle('sold', soldOut);
    });
    var atc = document.getElementById('gfg-atc');
    var priceEl = document.getElementById('gfg-price');
    var idInput = document.getElementById('gfg-variant-id');
    var stickP = document.querySelector('.sticky-atc .p');
    if(v){
      idInput.value = v.id;
      priceEl.innerHTML = fmtPrice(v);
      atc.disabled = !v.available;
      atc.textContent = v.available ? ('Add to cart · '+money(v.price)) : 'Sold out';
      var stickBtn = document.getElementById('gfg-sticky-atc');
      if(stickBtn){ stickBtn.disabled = !v.available; stickBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if(stickP) stickP.textContent = money(v.price) + (chosen.length ? ' · '+chosen.join(' / ') : '');
      // swap gallery image if the variant has its own
      if(v.featured_image && v.featured_image.src){
        var main = document.querySelector('.gallery__main img'); if(main) main.src = v.featured_image.src;
      }
    } else {
      atc.disabled = true; atc.textContent = 'Unavailable';
    }
  }
  root.querySelectorAll('.optbtn').forEach(function(b){
    b.addEventListener('click', function(){
      chosen[+b.dataset.optIndex] = b.dataset.value; render();
    });
  });
  render();

  // gallery thumbs
  document.querySelectorAll('.gthumb').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.gthumb').forEach(x=>x.classList.remove('active')); t.classList.add('active');
      var main = document.querySelector('.gallery__main img'); if(main) main.src = t.dataset.full;
    });
  });
  // quantity
  var qty = document.getElementById('gfg-qty');
  root.querySelectorAll('.qty button').forEach(function(b){
    b.addEventListener('click', function(){ qty.value = Math.max(1,(parseInt(qty.value,10)||1)+parseInt(b.dataset.step,10)); });
  });
  // accordions
  root.querySelectorAll('.acc').forEach(function(a){
    var body=a.querySelector('.acc__body');
    if(a.classList.contains('open')) body.style.maxHeight=body.scrollHeight+'px';
    a.querySelector('.acc__head').addEventListener('click', function(){
      var open=a.classList.toggle('open'); body.style.maxHeight = open ? body.scrollHeight+'px' : 0;
    });
  });
  // add to cart (AJAX)
  function toast(msg){ var t=document.getElementById('gfg-toast'); if(!t)return; t.textContent=msg; t.classList.add('show'); clearTimeout(t._t); t._t=setTimeout(function(){t.classList.remove('show');},1800); }
  function addToCart(){
    var v=findVariant();
    if(!v){ toast('Select options'); return; }
    if(!v.available){ toast('Sold out'); return; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:parseInt(qty.value,10)||1})})
      .then(r=>r.json()).then(function(){
        return fetch('/cart.js').then(r=>r.json());
      }).then(function(cart){
        document.querySelectorAll('.uicon.cart .count').forEach(function(c){ c.textContent=cart.item_count; });
        toast('Added to cart');
      }).catch(function(){ toast('Something went wrong'); });
  }
  var atcBtn=document.getElementById('gfg-atc'); if(atcBtn) atcBtn.addEventListener('click', function(e){ e.preventDefault(); addToCart(); });
  var stickyBtn=document.querySelector('.sticky-atc button'); if(stickyBtn) stickyBtn.addEventListener('click', addToCart);
  // sticky ATC visibility (mobile)
  if('IntersectionObserver' in window && atcBtn){
    var bar=document.querySelector('.sticky-atc');
    new IntersectionObserver(function(en){ en.forEach(function(e){ if(bar) bar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top<0); }); },{threshold:0}).observe(atcBtn);
  }
})();

/* ===================== COLLECTION: filter + sort ===================== */
(function(){
  var grid=document.getElementById('gfg-grid'); if(!grid) return;
  var cards=[].slice.call(grid.querySelectorAll('.pcard')), empty=document.getElementById('gfg-empty');
  var chips=[].slice.call(document.querySelectorAll('.chip')), sortSel=document.getElementById('gfg-sort'), countLbl=document.getElementById('gfg-count');
  var filter='all';
  function apply(){
    var shown=0;
    cards.forEach(function(c){ var ok=filter==='all'||c.dataset.type===filter; c.classList.toggle('hide',!ok); if(ok)shown++; });
    if(empty) empty.style.display=shown?'none':'block';
    if(countLbl) countLbl.textContent=shown+' item'+(shown!==1?'s':'');
  }
  function sortCards(){
    var v=sortSel.value, arr=cards.slice();
    arr.sort(function(a,b){
      if(v==='price-asc')return a.dataset.price-b.dataset.price;
      if(v==='price-desc')return b.dataset.price-a.dataset.price;
      if(v==='title')return a.dataset.title.localeCompare(b.dataset.title);
      return 0;
    });
    arr.forEach(function(c){ grid.insertBefore(c, empty); });
  }
  /* Drafted/unavailable products still appear in collection.all_types, which renders
     dead filter tabs. On single-page collections every card is in the DOM, so a chip with
     no matching card is provably empty and safe to remove. Paginated collections are
     skipped: a chip's products may simply live on another page. */
  var toolbar=document.querySelector('.toolbar');
  if(toolbar && toolbar.dataset.singlePage==='true'){
    var present={};
    cards.forEach(function(c){ if(c.dataset.type) present[c.dataset.type]=1; });
    chips=chips.filter(function(ch){
      var f=ch.dataset.filter;
      if(f!=='all' && !present[f]){ ch.parentNode.removeChild(ch); return false; }
      return true;
    });
  }
  chips.forEach(function(ch){ ch.addEventListener('click', function(){ chips.forEach(x=>x.classList.remove('active')); ch.classList.add('active'); filter=ch.dataset.filter; apply(); }); });
  if(sortSel) sortSel.addEventListener('change', function(){ if(sortSel.value!=='featured') sortCards(); apply(); });
  apply();
})();

/* Filter toolbar: robust JS fixed-pin (position:sticky proved unreliable across browsers) */
(function(){
  var toolbar=document.querySelector('.toolbar'); if(!toolbar) return;
  var OFFSET=59, pinned=false;
  var ph=document.createElement('div'); ph.className='toolbar-ph'; ph.setAttribute('aria-hidden','true'); ph.style.display='none';
  toolbar.parentNode.insertBefore(ph, toolbar);
  function pin(){
    var mt=parseFloat(getComputedStyle(toolbar).marginTop)||0;
    ph.style.height=(toolbar.offsetHeight+mt)+'px'; ph.style.display='block';
    var r=ph.getBoundingClientRect();
    toolbar.style.left=Math.round(r.left)+'px'; toolbar.style.width=Math.round(r.width)+'px';
    toolbar.classList.add('is-pinned'); pinned=true;
  }
  function unpin(){
    toolbar.classList.remove('is-pinned'); toolbar.style.left=''; toolbar.style.width=''; ph.style.display='none'; pinned=false;
  }
  function isMobile(){ return window.innerWidth <= 600; }   // phones: let the tabs scroll with the page
  function check(){
    if(isMobile()){ if(pinned) unpin(); return; }           // mobile: never pin (desktop behavior unchanged)
    if(!pinned){ if(toolbar.getBoundingClientRect().top<=OFFSET) pin(); }
    else if(ph.getBoundingClientRect().top>OFFSET){ unpin(); }
  }
  window.addEventListener('scroll', check, {passive:true});
  window.addEventListener('resize', function(){ if(pinned){ unpin(); } check(); });
  check();
})();
